import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const LeagueTeamsRemoveDialog = makeConfirmActionDialog({
  mutationName: "leagueTeamsRemove",
  paramName: "leagueTeamIds",
  action: "Remove",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Remove",
    };
  },
});
